export default __webpack_public_path__ + "static/key-f1321676f82abb8859777330fcfc25bc.png";